export type TStatus =
  | "NOT_DELIVERED"
  | "IN_PROGRESS"
  | "DELIVERED"
  | "SCHELUDED"
  | "OUT_OF_DATE"
  | "";

export const Statuses = {
  NOT_DELIVERED: "NOT_DELIVERED" as TStatus,
  IN_PROGRESS: "IN_PROGRESS" as TStatus,
  FINISHED: "DELIVERED" as TStatus,
  SCHEDULED: "SCHEDULED" as TStatus,
  OUT_OF_DATE: "OUT_OF_DATE" as TStatus,
  OTHER: "" as TStatus,
};

export type TStatusSend = "CANDIDATE" | "TIMER";

export const StatusesSend = {
  CANDIDATE: "CANDIDATE" as TStatusSend,
  TIMER: "TIMER" as TStatusSend,
};
